export enum PaymentTypeEnum {
    PerMemberPerMonth = 1,
    ProratedPerMemberPerMonth = 2,
}
